<template>
  <div v-if="false"></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import ImageTileLayer from 'ol/layer/Tile' 
import XYZSource from 'ol/source/XYZ'      
import TileState from 'ol/TileState'
import { PMTiles } from 'pmtiles'          
import { createXYZ } from 'ol/tilegrid'

const props = defineProps(['layer', 'map'])
const instancedLayer = ref(null)

// Imposta il VERO limite del file PMTiles. Se il file si ferma a 15, metti 15.
// OpenLayers farà automaticamente lo stretch delle tile se la View va a zoom 18.
const maxZoom = props.layer.properties.config.maxZoom || 18; 
const minZoom = props.layer.properties.config.minZoom || 4;

const removeLayer = () => {
  if (!instancedLayer.value) return;
  
  const source = instancedLayer.value.getSource();
  if (source && typeof source.dispose === 'function') source.dispose();
  if (typeof instancedLayer.value.dispose === 'function') instancedLayer.value.dispose();
  
  props.map.removeLayer(instancedLayer.value);
}

const addLayer = () => {
  const pmtilesInstance = new PMTiles(props.layer.url);

  const minimalSource = new XYZSource({
    tileGrid: createXYZ({ maxZoom: maxZoom, minZoom: minZoom }),
    tilePixelRatio: 1, 
    
    url: '{z}/{x}/{y}', 
    tileLoadFunction: async (imageTile) => {
      imageTile.setState(TileState.LOADING);
      const [z, x, y] = imageTile.getTileCoord();

      try {
        const response = await pmtilesInstance.getZxy(z, x, y);
        
        if (!response) {
          imageTile.setState(TileState.EMPTY);
          return;
        }

        const imageElement = imageTile.getImage();
        const blobUrl = URL.createObjectURL(new Blob([response.data], { type: 'image/png' }));

        // CRITICO PER LA MEMORIA: Pulizia istantanea dei Blob non appena caricati o falliti
        imageElement.addEventListener('load', () => {
          imageTile.setState(TileState.LOADED);
          URL.revokeObjectURL(blobUrl);
        });
        
        imageElement.addEventListener('error', () => {
          imageTile.setState(TileState.ERROR);
          URL.revokeObjectURL(blobUrl);
        });

        imageElement.src = blobUrl;
        
      } catch (error) {
        console.error(`[PMTiles] Errore a Z:${z}`, error);
        imageTile.setState(TileState.ERROR);
      }
    }
  });

  instancedLayer.value = new ImageTileLayer({
    source: minimalSource
  });

  props.map.addLayer(instancedLayer.value);
}

onMounted(() => {
  addLayer()
})

onUnmounted(() => {
  removeLayer()
})
</script>
